// Rsql custom operators
// https://github.com/piotr-oles/rsql#custom-operators
const IS_NULL = "=isnull=";
const IS_NOT_NULL = "=isnotnull=";
const SIMPLE_SEARCH = "=simpleSearch=";
const ADVANCED_SEARCH = "=search=";
const ALL = "=all=";
const EMPTY = "=empty=";
const JSON_EQ = "=jsoneq=";

export {
  ADVANCED_SEARCH,
  ALL,
  EMPTY,
  IS_NOT_NULL,
  IS_NULL,
  JSON_EQ,
  SIMPLE_SEARCH
};
